var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seletrr"},[_c('treeselect',{attrs:{"options":_vm.treeList,"value":_vm.value,"normalizer":_vm.normalizer},on:{"select":_vm.selectDepart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }